import * as React from "react";
import { Grid } from "@mui/material";
import { formatZip } from "../utils/StringHelper";
import { ImagesContext } from "../Context";

interface Props {
  organization: any;
}

const OrganizationDetails: React.FC<Props> = ({ organization }) => {
  const images = React.useContext(ImagesContext);

  return (
    <Grid item xs={12} className="info-container">
      <div className="overview-container row">
        <div className="item-icon-container">
          <img
            src={images.organization_icon}
            alt="Insurance Icon"
            className="action-icon-image"
            style={{ width: 23, maxHeight: 23 }}
          />
        </div>
        <div className="header-text-container">
          <div className="row">
            <h4 className="overview-header">{organization?.name}</h4>
            <h4 className="medical_id_text">
              #NPI: {organization?.facility_npi}
            </h4>
          </div>
          <p className="overview-detail">
            {[organization?.place_of_service_code]
              .filter(Boolean)
              .map((item, index, arr) => (
                <span key={index + 1}>
                  {item}
                  {index < arr.length - 1 && (
                    <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                  )}
                </span>
              ))}
          </p>
        </div>
      </div>
      <div className="divider"></div>
      <Grid container spacing={2}>
        <Grid item xs={3} className="patient-info-left-container">
          <div className="detail-container">
            <h4 className="detail-header">Address</h4>
            <p className="detail-text">{organization?.address}</p>
            {organization?.address_line_2 && (
              <p className="detail-text">{organization?.address_line_2}</p>
            )}
            <p className="detail-text">
              {organization?.city}
              {organization?.city && ","} {organization?.state}{" "}
              {formatZip(organization?.zip)}
            </p>
            <p className="detail-text">{organization?.county}</p>
          </div>
        </Grid>
        <Grid item xs={4.5} className="patient-info-left-container">
          <div className="detail-container">
            <h4 className="detail-header">Additional Info</h4>
            {organization?.federal_tax_id && (
              <p className="detail-text">
                Federal Tax ID #: {organization?.federal_tax_id}
              </p>
            )}
            {organization?.waystar_id && (
              <p className="detail-text">
                Waystar ID: {organization?.waystar_id}
              </p>
            )}
            {organization?.id_qualifier && (
              <p className="detail-text">
                ID Qualifier: {organization?.id_qualifier}
              </p>
            )}
            {organization?.provider_number && (
              <p className="detail-text">
                Provider Number: {organization?.provider_number}
              </p>
            )}
            {organization?.notes && (
              <p className="detail-text">Notes: {organization?.notes}</p>
            )}
          </div>
        </Grid>
        <Grid item xs={4} className="patient-info-left-container">
          <div className="detail-container">
            <h4 className="detail-header">Contact</h4>
            {organization?.phone_number && (
              <p className="detail-text">{organization?.phone_number}</p>
            )}
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationDetails;
